import React from 'react';
import { MBView } from '@shared/components/MBView';
import { MBUserImage } from '@shared/components/image';
import { Styles } from '../styles';

interface MBSenderImageProps {
  message: MBAPI.ChatMessage;
  layout?: MBChatMessageLayoutOptions;
}

/*
    Image of the sender. If the message bubble is grouped with the one below
    (actually the one above, since chat is inverted), we just render a
    placeholder. Only the last image of a group is visible.
*/
export function MBSenderImage({ message, layout }: MBSenderImageProps) {
  if (layout?.isGroupedWithBelow) {
    return <MBView style={Styles.userImagePlaceholder} />;
  }

  return <MBUserImage user={message.sender} style={Styles.userImage} />;
}
